export default __webpack_public_path__ + "static/media/Care08.d96741c4.png";